import React, { Component } from "react";
import { Link } from "react-router-dom";
import { BounceLoader } from "react-spinners";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import Taskbar from "../Taskbar";
import "./PostBounty.css";
import { getUserData } from "../../utils/user";

function CameraUpload(props) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  if (acceptedFiles.length > 0) {
    props.getPhoto(acceptedFiles[0]);
  }

  // Abstract all style={{ height: "100%", width: "100%" }} to a class

  return (
    <section
      style={{
        height: "100%",
        width: "100%"
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%"
        }}
        {...getRootProps()}
      >
        <input name="file" {...getInputProps()} />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexFlow: "column",
            height: "100%",
            width: "100%"
          }}
        >
          <i
            className="far fa-image"
            style={{ color: "#F5841D", fontSize: "3rem" }}
          />
          <p className="upload-image-button">Upload image</p>
        </div>
      </div>
    </section>
  );
}
export default class PostBounty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bounty: "",
      focusTitle: false,
      title: "",
      photo: null,
      name: "",
      submitted: false,
      isLoading: false
    };
  }

  componentDidMount = async () => {
    const { data, status } = await getUserData(true);

    try {
      if (status === 200) {
        this.setState({
          username: data.email.split("@")[0],
          userId: data.id
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  clearForm = () => {
    this.setState(
      {
        submitted: false,
        bounty: "",
        title: "",
        photo: null,
        photoURL: ""
      },
      () => this.props.toggleTab(false)
    );
  };

  getPhoto = file => {
    this.setState({
      photoURL: URL.createObjectURL(file),
      photo: file,
      name: file.name
    });
  };

  inputFocus = section => {
    this.setState({
      [section]: true
    });
  };

  inputBlur = section => {
    if (section === "title") {
      const { title } = this.state;
      this.setState({
        focusTitle: title !== ""
      });
    } else {
      const { bounty } = this.state;
      this.setState({
        focusBounty: bounty !== ""
      });
    }
  };

  submitForm = async () => {
    const { bounty, photo, username, userId, title } = this.state;
    this.setState({
      isLoading: true
    });

    var payload = new FormData();
    payload.append("file", photo);
    payload.append("bounty", bounty);
    payload.append("title", title);
    payload.append("username", username);
    payload.append("userId", userId);

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(async position => {
        payload.append("latitude", position.coords.latitude);
        payload.append("longitude", position.coords.longitude);
        const { data, status } = await axios.post(
          // `https://api.trashero.net/bounty/upload`,
          `http://localhost:80/bounty/upload`,
          payload,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );

        if (status === 200) {
          this.setState(
            {
              submitted: true,
              bounty: "",
              title: "",
              photo: null,
              photoURL: "",
              isLoading: false
            },
            () => this.props.toggleTab(true)
          );
        } else {
          this.setState({
            isLoading: false
          });
        }
      });
    } else {
      /* geolocation IS NOT available */
      this.setState({
        isLoading: false
      });
    }
  };

  render() {
    const {
      focusBounty,
      focusTitle,
      isLoading,
      name,
      photoURL,
      submitted
    } = this.state;

    return (
      <React.Fragment>
        <Taskbar
          title={"Post a bounty"}
          back={() => {
            this.props.setPage(this.props.prevPath);
            this.props.history.goBack();
          }}
        />
        {submitted ? (
          <div className="splash-screen">
            <i className="fas fa-check" />
            <div>Posted!</div>
            <Link
              className="splash-screen-button"
              onClick={() => this.clearForm()}
              to={{ pathname: "/" }}
            >
              Ok
            </Link>
          </div>
        ) : isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              background: "#73cfa4"
            }}
          >
            <BounceLoader
              sizeUnit={"px"}
              size={50}
              color={"#ffffff"}
              loading={isLoading}
            />
          </div>
        ) : (
          <div className="bounty-form-container shadowed">
            <form action="." encType="multipart/form-data">
              <div className="bounty-input-container">
                <div
                  className={`bounty-input-label ${
                    focusTitle ? "label-selected" : '"'
                  }`}
                  style={{ width: "3rem" }}
                >
                  Title
                </div>
                <div className="bounty-input-field">
                  <input
                    className="bounty-input"
                    onFocus={() => this.inputFocus("focusTitle")}
                    onBlur={() => this.inputBlur("title")}
                    onChange={e => this.setState({ title: e.target.value })}
                  />
                </div>
              </div>
              <div className="bounty-input-container">
                <div
                  className={`bounty-input-label ${
                    focusBounty ? "label-selected" : '"'
                  }`}
                  style={{ width: "5rem" }}
                >
                  Bounty
                </div>
                <div className="bounty-input-field">
                  <input
                    className="bounty-input"
                    onFocus={() => this.inputFocus("focusBounty")}
                    onBlur={() => this.inputBlur("bounty")}
                    onChange={e => this.setState({ bounty: e.target.value })}
                  />
                </div>
              </div>
              <div className="bounty-image-upload-container">
                {name !== "" ? (
                  <div>
                    <img
                      src={photoURL}
                      style={{ height: "30vh", width: "66vw" }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      height: "100%",
                      width: "100%"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%"
                      }}
                    >
                      <CameraUpload getPhoto={this.getPhoto} />
                    </div>
                  </div>
                )}
              </div>
              <div className="bounty-upload-button" onClick={this.submitForm}>
                Submit Bounty
              </div>
            </form>
          </div>
        )}
        ;
      </React.Fragment>
    );
  }
}
